import type { PropsWithChildren } from "react";

import { Navigate, useLocation } from "react-router";

import { useAuthContext } from "@/services/auth";

export const AuthRouteGate = ({ children }: PropsWithChildren) => {
  const { hasToken } = useAuthContext();
  const location = useLocation();

  // If token is defined send user to Dashboard
  if (hasToken) {
    return <Navigate to="/" state={{ from: location }} />;
  }

  // Otherwise render auth routes
  return children;
};
